/* eslint-disable no-unused-vars, no-undef, no-return-assign, camelcase, no-dupe-class-members, no-trailing-spaces */
class RoofBarFinderRedesign extends HTMLElement {
  static isDev = false
  static popularMakes = {
    Ford: 1,
    Vauxhall: 2,
    Volkswagen: 3,
    Toyota: 4,
    Nissan: 5,
    'Mercedes-Benz': 6,
    BMW: 7,
    Audi: 8,
    MINI: 9,
    Peugeot: 10,
    Citroën: 11,
    Renault: 12,
    Volvo: 13,
    Honda: 14,
    Kia: 15,
  }

  constructor () {
    super()
    this.resetContainer = this.querySelector('.roof-bar-finder__reset')
    this.resetButton = this.querySelector('.roof-bar-finder__reset-button')
    this.wording = JSON.parse(this.dataset.wordingObject || '{}')
    this.isDataLoaded = false
    this.hasUserInteracted = false
    this.intersectionObserver = null
    this.resizeObserver = null
    
    this.carData = carData
    this.isDataLoaded = true
    this.init()
  }

  get apiBase () {
    return this.getAttribute('data-api-base') || 'https://tentbox.tools/api/web/vehicle-checker'
  }

  getSessionId () {
    let sessionId = sessionStorage.getItem('tentboxSessionId')
    if (!sessionId) {
      sessionId = Math.random().toString(36).substring(2) + Date.now().toString(36)
      sessionStorage.setItem('tentboxSessionId', sessionId)
    }
    return sessionId
  }

  async logResult () {
    try {
      const ipInfo = JSON.parse(localStorage.getItem('tentboxIpInfo') || '{"data": {}}')
      const ip = ipInfo?.data?.ip || null
      const sessionId = this.getSessionId()
      const response = await fetch(`${this.apiBase}/log-result`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tool: 'roofBarFinder',
          make: this.selectedMake,
          model: this.selectedModel || '',
          rooftype: this.selectedRoofType || '',
          generation: this.selectedGeneration || 'All',
          ip,
          session_id: sessionId,
        }),
      })
      if (!response.ok) {
        console.error('Failed to log result:', response.status, await response.text())
      }
    } catch (error) {
      console.error('Error logging result:', error)
    }
  }

  async init () {
    if (!this.isDataLoaded) {
      await new Promise(resolve => {
        const checkInterval = setInterval(() => {
          if (this.isDataLoaded) {
            clearInterval(checkInterval)
            resolve()
          }
        }, 100)
      })
    }
    
    const sharedInfo = localStorage.getItem('sharedVehicleInfo')
    if (sharedInfo) {
      try {
        const parsed = JSON.parse(sharedInfo)
        if (!parsed?.make || parsed.make === 'undefined') {
          localStorage.removeItem('sharedVehicleInfo')
        }
      } catch (err) {
        localStorage.removeItem('sharedVehicleInfo')
      }
    }
    this.cacheElements()
    this.setupState()
    this.initializeHiddenSections()
    const urlParams = this.parseUrlParams()
    if (urlParams.make) {
      await this.restoreFromUrlParams(urlParams)
    } else {
      await this.restoreSharedVehicleInfo()
    }
    this.bindEvents()
    this.initializeFuzzySearch()
    this.initializeStickyNotice()
  }

  parseUrlParams () {
    const searchParams = new URLSearchParams(window.location.search)
    return {
      make: searchParams.get('make'),
      model: searchParams.get('model'),
      doors: searchParams.get('doors'),
      roofType: searchParams.get('roof_type'),
      generation: searchParams.get('generation'),
      lastInput: searchParams.get('last_input'),
    }
  }

  get resultContainer () {
    return this.querySelector('.result-container')
  }

  get gridContainer () {
    const container = this.resultContainer
    return container ? container.querySelector('.product-recommendations__grid') : null
  }

  updateUrlParams (param, value) {
    const url = new URL(window.location.href)
    if (value) {
      url.searchParams.set(param, value)
    } else {
      url.searchParams.delete(param)
    }
    window.history.replaceState({}, '', url)
  }

  setLastInput (inputType) {
    this.updateUrlParams('last_input', inputType)
  }

  clearUrlParams () {
    const url = new URL(window.location.href)
    url.search = ''
    window.history.replaceState({}, '', url)
  }

  cacheElements () {
    this.makeInput = this.querySelector('#car_make_input')
    this.modelInput = this.querySelector('#car_model_input')
    this.roofTypeInput = this.querySelector('#roof_type_input')
    this.generationInput = this.querySelector('#car_generation_input')
    this.makeSuggestions = this.querySelector('#make-suggestions')
    this.modelSuggestions = this.querySelector('#model-suggestions')
    this.roofTypeSuggestions = this.querySelector('#roof-type-suggestions')
    this.generationSuggestions = this.querySelector('#generation-suggestions')
    this.makeResetBtn = this.querySelector('#car_make_input').parentElement.querySelector('.roof-bar-finder__input-reset')
    this.modelResetBtn = this.querySelector('#car_model_input').parentElement.querySelector('.roof-bar-finder__input-reset')
    this.roofTypeResetBtn = this.querySelector('#roof_type_input').parentElement.querySelector('.roof-bar-finder__input-reset')
    this.generationResetBtn = this.querySelector('#car_generation_input').parentElement.querySelector('.roof-bar-finder__input-reset')
    this.initialNoticeContainer = this.querySelector('.initial-notice-container')
    this.toolCtaElement = this.querySelector('.tool-cta')
    this.helperSection = this.querySelector('.roof-bar-finder__helper')
  }

  setupState () {
    this.selectedMake = null
    this.selectedModel = null
    this.selectedDoors = null
    this.selectedRoofType = null
    this.selectedGeneration = null
  }

  initializeHiddenSections () {
    const hiddenSectionsStr = this.dataset.hiddenSections
    if (!hiddenSectionsStr) {
      this.hiddenSectionIds = []
      return
    }
    this.hiddenSectionIds = hiddenSectionsStr.split(',').map(id => id.trim()).filter(Boolean)
    this.hideAllSections()
  }

  hideAllSections () {
    if (!this.hiddenSectionIds?.length) return
    this.hiddenSectionIds.forEach(sectionId => {
      const section = document.getElementById(sectionId)
      if (section) {
        section.style.display = 'none'
      }
    })
  }

  showAllSections () {
    if (!this.hiddenSectionIds?.length) return
    this.hiddenSectionIds.forEach(sectionId => {
      const section = document.getElementById(sectionId)
      if (section) {
        section.style.display = ''
      }
    })
  }

  bindEvents () {
    if (this.makeInput && this.makeSuggestions) {
      this.bindSuggestionInput(
        this.makeInput,
        this.makeSuggestions,
        this.showMakeSuggestions.bind(this),
        this.selectMake.bind(this),
      )
      this.bindInputVisibility(this.makeInput, this.makeResetBtn)
    }
    if (this.modelInput && this.modelSuggestions) {
      this.bindSuggestionInput(
        this.modelInput,
        this.modelSuggestions,
        this.showModelSuggestions.bind(this),
        this.selectModel.bind(this),
        () => !!this.selectedMake,
      )
      this.bindInputVisibility(this.modelInput, this.modelResetBtn)
    }
    if (this.roofTypeInput && this.roofTypeSuggestions) {
      this.bindSuggestionInput(
        this.roofTypeInput,
        this.roofTypeSuggestions,
        this.showRoofTypeSuggestions.bind(this),
        this.selectRoofType.bind(this),
        () => !!this.selectedModel,
      ) 
      this.bindInputVisibility(this.roofTypeInput, this.roofTypeResetBtn)
    }
    if (this.generationInput && this.generationSuggestions) {
      this.bindSuggestionInput(
        this.generationInput,
        this.generationSuggestions,
        this.showGenerationSuggestions.bind(this),
        this.selectGeneration.bind(this),
        () => !!this.selectedRoofType,
      )
      this.bindInputVisibility(this.generationInput, this.generationResetBtn)
    }
    if (this.makeResetBtn) {
      this.makeResetBtn.addEventListener('click', () => this.resetForm())
    }
    if (this.modelResetBtn) {
      this.modelResetBtn.addEventListener('click', () => this.resetFromModel())
    }
    if (this.roofTypeResetBtn) {
      this.roofTypeResetBtn.addEventListener('click', () => this.resetFromRoofType())
    }
    if (this.generationResetBtn) {
      this.generationResetBtn.addEventListener('click', () => this.resetFromGeneration())
    }
    this.resetButton.addEventListener('click', () => this.resetForm())
  }

  getUniqueMakes () {
    if (!this.carData?.length) {
      return []
    }
    return [...new Set(this.carData.map(item => item.make))].sort()
  }

  getUniqueModels (make) {
    if (!make || !this.carData?.length) {
      return []
    }
    
    const filteredData = this.carData
      .filter(item => this.normalizeString(item.make) === this.normalizeString(make))
      .filter(item => item.model !== null && item.model !== undefined)
    
    const modelDoorsMap = new Map()
    
    filteredData.forEach(item => {
      const model = String(item.model)
      const doors = item.doors || ''
      const key = `${model}|${doors}`
      
      if (!modelDoorsMap.has(key)) {
        modelDoorsMap.set(key, { model, doors })
      }
    })
    
    const uniqueModels = Array.from(modelDoorsMap.values())
    
    const result = uniqueModels.map(({ model, doors }) => {
      let displayLabel = model
      
      if (doors) {
        const doorsLower = doors.toLowerCase()
        displayLabel = `${model} (${doorsLower})`
      }
      
      return {
        model,
        doors,
        displayLabel,
      }
    })
    
    result.sort((a, b) => {
      const modelCompare = a.model.localeCompare(b.model)
      if (modelCompare !== 0) return modelCompare
      return (a.doors || '').localeCompare(b.doors || '')
    })
    
    return result
  }

  normalizeString (str) {
    if (!str || typeof str !== 'string') return ''
    return str.toLowerCase().replace(/[^a-z0-9]/g, '')
  }

  hideSuggestions (container) {
    container.classList.add('hidden')
  }

  resetForm () {
    localStorage.removeItem('sharedVehicleInfo')
    this.clearUrlParams()

    this.makeInput.value = ''
    this.modelInput.value = ''
    this.roofTypeInput.value = ''
    this.generationInput.value = ''
    this.makeInput.classList.remove('completed')
    this.modelInput.classList.remove('completed')
    this.roofTypeInput.classList.remove('completed')
    this.generationInput.classList.remove('completed')
    this.selectedMake = null
    this.selectedModel = null
    this.selectedDoors = null
    this.selectedRoofType = null
    this.selectedGeneration = null
    this.modelInput.disabled = true
    this.roofTypeInput.disabled = true
    this.generationInput.disabled = true

    const makeChevron = this.makeInput.parentElement.querySelector('.input-chevron')
    if (makeChevron) {
      makeChevron.classList.remove('hidden')
    }
    const makeTick = this.makeInput.parentElement.querySelector('.roof-bar-finder__input-tick')
    if (makeTick) makeTick.classList.add('hidden')
    const modelTick = this.modelInput.parentElement.querySelector('.roof-bar-finder__input-tick')
    if (modelTick) modelTick.classList.add('hidden')
    const roofTypeTick = this.roofTypeInput.parentElement.querySelector('.roof-bar-finder__input-tick')
    if (roofTypeTick) roofTypeTick.classList.add('hidden')
    const generationTick = this.generationInput.parentElement.querySelector('.roof-bar-finder__input-tick')
    if (generationTick) generationTick.classList.add('hidden')
    this.makeResetBtn.classList.add('hidden')
    this.modelResetBtn.classList.add('hidden')
    this.roofTypeResetBtn.classList.add('hidden')
    this.generationResetBtn.classList.add('hidden')
    this.resetContainer.classList.add('hidden')
    this.resetButton.classList.add('hidden')
    this.classList.remove('has-reset-button')
    this.clearResults()
    setTimeout(() => {
      this.makeInput.focus()
    }, 100)
  }

  clearResults () {
    const resultContainer = this.resultContainer
    if (resultContainer) {
      resultContainer.classList.add('hidden')
      const gridContainer = this.gridContainer
      if (gridContainer) {
        gridContainer.innerHTML = ''
      }
    }
    
    // Show initial notice container when results are cleared
    if (this.initialNoticeContainer) {
      this.initialNoticeContainer.classList.remove('hidden')
    }
    
    // Show helper section when results are cleared
    if (this.helperSection) {
      this.helperSection.classList.remove('hidden')
    }
  }

  bindSuggestionInput (input, suggestionsContainer, showCallback, selectCallback, enableCondition = () => true) {
    if (!input || !suggestionsContainer) return
    const isNonSearchable = input === this.roofTypeInput || input === this.generationInput
    
    if (!isNonSearchable) {
      input.addEventListener('input', () => {
        if (enableCondition()) {
          const query = input.value || ''
          if (typeof query === 'string') {
            showCallback(query)
          }
        }
      })
    }
    
    input.addEventListener('focus', () => {
      if (enableCondition()) {
        if (isNonSearchable) {
          showCallback('')
        } else {
          const query = input.value || ''
          if (typeof query === 'string') {
            showCallback(query)
          }
        }
      }
    })
    
    input.addEventListener('blur', (e) => {
      if (!e.relatedTarget?.closest(`#${suggestionsContainer.id}`)) {
        this.hideSuggestions(suggestionsContainer)
      }
    })
    
    // Add keyboard navigation for input field
    input.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') {
        e.preventDefault()
        const firstItem = suggestionsContainer.querySelector('li[data-value]')
        firstItem?.focus()
      } else if (e.key === 'Tab' && !suggestionsContainer.classList.contains('hidden')) {
        // Allow tab to move to first dropdown item if dropdown is open
        const firstItem = suggestionsContainer.querySelector('li[data-value]')
        if (firstItem) {
          e.preventDefault()
          firstItem.focus()
        }
      } else if (e.key === 'Escape') {
        e.preventDefault()
        this.hideSuggestions(suggestionsContainer)
        input.focus()
      }
    })
    
    suggestionsContainer.addEventListener('mousedown', (e) => {
      e.preventDefault()
      const li = e.target.closest('li')
      if (li && li.dataset.value) {
        selectCallback(li.dataset.value || li.textContent.trim())
      }
    })
    
    // Add keyboard navigation for suggestion items
    suggestionsContainer.addEventListener('keydown', (e) => {
      this.handleSuggestionsKeydown(e, input, suggestionsContainer, (li) => {
        selectCallback(li.dataset.value || li.textContent.trim())
      })
    })
  }

  handleSuggestionsKeydown (e, input, container, selectCallback) {
    const items = Array.from(container.querySelectorAll('li[data-value]'))
    if (items.length === 0) return
    
    const currentFocusedElement = document.activeElement
    let currentIndex = -1
    
    if (container.contains(currentFocusedElement) && currentFocusedElement.tagName === 'LI') {
      currentIndex = items.indexOf(currentFocusedElement)
    }
    
    switch (e.key) {
      case 'ArrowDown': {
        e.preventDefault()
        const nextIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0
        items[nextIndex]?.focus()
        break
      }
      case 'ArrowUp':
        e.preventDefault()
        if (currentIndex > 0) {
          items[currentIndex - 1]?.focus()
        } else if (currentIndex === 0) {
          input.focus()
        } else {
          items[items.length - 1]?.focus()
        }
        break
      case 'Enter':
      case ' ':
        if (currentIndex !== -1) {
          e.preventDefault()
          selectCallback(items[currentIndex])
          this.hideSuggestions(container)
        }
        break
      case 'Escape':
        e.preventDefault()
        this.hideSuggestions(container)
        input.focus()
        break
      case 'Tab':
        this.hideSuggestions(container)
        break
    }
  }

  bindInputVisibility (input, resetButton) {
    const chevron = input.parentElement.querySelector('.input-chevron')
    if (!chevron || !resetButton) return
    
    const updateVisibility = () => {
      const hasValue = input.value.trim() !== ''
      const isDisabled = input.disabled
      const isCompleted = input.classList.contains('completed')
      
      if (isCompleted) {
        return
      }
      
      if (hasValue && !isDisabled) {
        chevron.classList.add('hidden')
        setTimeout(() => {
          resetButton.classList.remove('hidden')
        }, 10)
      } else {
        resetButton.classList.add('hidden')
        setTimeout(() => {
          chevron.classList.remove('hidden')
        }, 10)
      }
    }
    
    updateVisibility()
    input.addEventListener('input', updateVisibility)
    input.addEventListener('focus', updateVisibility)
    input.addEventListener('blur', updateVisibility)
  }

  initializeFuzzySearch () {
    const fuseScriptUrl = 'https://cdn.jsdelivr.net/npm/fuse.js@7.0.0/dist/fuse.min.js'
    const initFuse = () => {
      this.fuseOptions = {
        threshold: 0.3,
        ignoreLocation: true,
        keys: ['label'],
      }
    }
    window.Tentbox.loadScript(fuseScriptUrl, initFuse)
  }

  showMakeSuggestions (query = '') {
    const makes = this.getUniqueMakes().map(make => ({ label: make }))
    if (!makes?.length) {
      return
    }
    let filtered = makes
    if (query && window.Fuse) {
      const fuse = new Fuse(makes, this.fuseOptions)
      filtered = fuse.search(query).map(result => result.item)
    } else if (query) {
      filtered = makes.filter(make =>
        make.label.toLowerCase().includes(query.toLowerCase()),
      )
    }
    
    if (!query) {
      const popularMakes = []
      const allMakes = []
      const dataPopularMakes = this.getUniqueMakes().filter(make =>
        make in RoofBarFinderRedesign.popularMakes,
      ).sort((a, b) => a.localeCompare(b))
      const topPopularMakes = dataPopularMakes.slice(0, 15)
      if (topPopularMakes.length > 0) {
        popularMakes.push({
          label: this.wording.popular_makes || 'Popular',
          isHeader: true,
        })
        topPopularMakes.forEach(make => {
          popularMakes.push({ label: make })
        })
        popularMakes.push({
          isDivider: true,
        })
        allMakes.push({
          label: this.wording.all_makes || 'All makes',
          isHeader: true,
        })
        const sortedMakes = [...makes].sort((a, b) => a.label.localeCompare(b.label))
        allMakes.push(...sortedMakes)
        this.renderSuggestionsWithCategories([...popularMakes, ...allMakes], this.makeSuggestions)
      } else {
        this.renderSuggestions(filtered, this.makeSuggestions)
      }
    } else {
      this.renderSuggestions(filtered, this.makeSuggestions)
    }
  }

  showModelSuggestions (query = '') {
    if (!this.selectedMake) return
    const uniqueModels = this.getUniqueModels(this.selectedMake)
    if (!uniqueModels?.length) {
      return
    }
    const filtered = uniqueModels.filter(item =>
      item.displayLabel.toLowerCase().includes(query.toLowerCase()),
    )
    this.renderSuggestions(
      filtered.map(item => ({ 
        label: item.displayLabel, 
        value: JSON.stringify({ model: item.model, doors: item.doors }),
      })),
      this.modelSuggestions,
    )
  }

  renderSuggestionsWithCategories (items, container) {
    if (!container) return
    container.innerHTML = ''
    if (!items || !items.length) {
      container.classList.add('hidden')
      return
    }
    items.forEach(item => {
      if (item.isHeader) {
        const header = document.createElement('li')
        header.classList.add(
          'px-3.5',
          'py-2',
          'font-semibold',
          'text-sm',
          'cursor-default',
          'bg-white',
        )
        header.textContent = item.label
        container.appendChild(header)
      } else if (item.isDivider) {
        const divider = document.createElement('li')
        divider.classList.add('border-t', 'border-steel', 'my-1', 'cursor-default')
        divider.setAttribute('aria-hidden', 'true')
        container.appendChild(divider)
      } else {
        const li = document.createElement('li')
        li.dataset.value = item.value || item.label
        li.dataset.label = item.label
        if (item.productHandle) {
          li.dataset.productHandle = item.productHandle
        }
        li.setAttribute('tabindex', '0')
        li.setAttribute('role', 'option')
        li.classList.add(
          'pl-4.5',
          'pr-3.5',
          'py-2.5',
          'cursor-pointer',
          'text-sm',
          'hover:bg-oat',
          'focus:bg-oat',
          'focus:outline',
          'focus:outline-2',
          'focus:outline-oat',
          'focus:outline-offset-[-1px]',
        )
        li.textContent = item.label
        container.appendChild(li)
      }
    })
    container.classList.remove('hidden')
    container.setAttribute('role', 'listbox')
  }

  renderSuggestions (items, container) {
    if (!container) {
      return
    }
    container.innerHTML = ''
    items.forEach(item => {
      const li = document.createElement('li')
      li.dataset.value = item.value || item.label
      li.dataset.label = item.label
      if (item.productHandle) {
        li.dataset.productHandle = item.productHandle
      }
      li.setAttribute('tabindex', '0')
      li.setAttribute('role', 'option')
      li.classList.add(
        'px-3.5',
        'py-2.5',
        'cursor-pointer',
        'text-sm',
        'hover:bg-oat',
        'focus:bg-oat',
        'focus:outline',
        'focus:outline-2',
        'focus:outline-oat',
        'focus:outline-offset-[-1px]',
      )
      li.textContent = item.label
      container.appendChild(li)
    })
    container.classList.remove('hidden')
    container.setAttribute('role', 'listbox')
  }

  selectMake (make) {
    this.selectedMake = make
    this.makeInput.value = make
    this.makeInput.classList.add('completed')
    const makeTick = this.makeInput.parentElement.querySelector('.roof-bar-finder__input-tick')
    if (makeTick) makeTick.classList.remove('hidden')
    const chevron = this.makeInput.parentElement.querySelector('.input-chevron')
    if (chevron) {
      chevron.classList.add('hidden')
    }
    this.makeResetBtn.classList.remove('hidden')
    this.modelInput.disabled = false
    this.resetContainer.classList.remove('hidden')
    this.resetButton.classList.remove('hidden')
    this.classList.add('has-reset-button')
    this.hideSuggestions(this.makeSuggestions)
    this.updateUrlParams('make', make)
    this.updateUrlParams('model', null)
    this.updateUrlParams('roof_type', null)
    this.updateUrlParams('generation', null)
    this.setLastInput('make')
    setTimeout(() => {
      this.modelInput.focus()
      this.showModelSuggestions('')
    }, 100)
  }

  selectModel (valueStr) {
    let model, doors, displayLabel
    
    try {
      const parsed = JSON.parse(valueStr)
      model = parsed.model
      doors = parsed.doors
      
      const uniqueModels = this.getUniqueModels(this.selectedMake)
      const matchingItem = uniqueModels.find(item => 
        item.model === model && item.doors === doors,
      )
      displayLabel = matchingItem ? matchingItem.displayLabel : model
    } catch (e) {
      model = valueStr
      doors = null
      displayLabel = model
    }
    
    this.selectedModel = model
    this.selectedDoors = doors
    this.modelInput.value = displayLabel
    this.modelInput.classList.add('completed')
    const modelTick = this.modelInput.parentElement.querySelector('.roof-bar-finder__input-tick')
    if (modelTick) modelTick.classList.remove('hidden')
    const chevron = this.modelInput.parentElement.querySelector('.input-chevron')
    if (chevron) {
      chevron.classList.add('hidden')
    }
    this.modelResetBtn.classList.remove('hidden')
    this.hideSuggestions(this.modelSuggestions)
    this.updateUrlParams('model', model)
    this.updateUrlParams('doors', doors)
    this.updateUrlParams('roof_type', null)
    this.updateUrlParams('generation', null)
    this.setLastInput('model')
    this.updateSharedVehicleStorage(this.selectedMake, model, doors)
    this.roofTypeInput.disabled = false
    setTimeout(() => {
      this.roofTypeInput.focus()
      this.showRoofTypeSuggestions('')
    }, 100)
  }

  async restoreSharedVehicleInfo () {
    try {
      const stored = localStorage.getItem('sharedVehicleInfo')
      if (!stored) return
      const sharedInfo = JSON.parse(stored)
      if (!sharedInfo?.make || sharedInfo.make === 'undefined') {
        localStorage.removeItem('sharedVehicleInfo')
        return
      }
      const normalizedStoredMake = this.normalizeString(sharedInfo.make)
      const makeExists = this.getUniqueMakes().some(make =>
        this.normalizeString(make) === normalizedStoredMake,
      )
      if (makeExists) {
        this.selectedMake = sharedInfo.make
        this.makeInput.value = sharedInfo.make
        this.makeInput.classList.add('completed')
        const makeChevron = this.makeInput.parentElement.querySelector('.input-chevron')
        if (makeChevron) {
          makeChevron.classList.add('hidden')
        }
        this.makeResetBtn.classList.remove('hidden')
        this.modelInput.disabled = false
        this.resetContainer.classList.remove('hidden')
        this.resetButton.classList.remove('hidden')
        this.classList.add('has-reset-button')
        this.updateUrlParams('make', sharedInfo.make)
        this.setLastInput('make')
        if (sharedInfo?.model && sharedInfo.model !== 'undefined') {
          const uniqueModels = this.getUniqueModels(sharedInfo.make)
          const matchingModel = uniqueModels.find(item => 
            item.model === sharedInfo.model && 
            (!sharedInfo.doors || item.doors === sharedInfo.doors),
          )
          
          if (matchingModel) {
            this.modelInput.disabled = false
            await new Promise(resolve => setTimeout(resolve, 100))
            this.selectedModel = matchingModel.model
            this.selectedDoors = matchingModel.doors
            this.modelInput.value = matchingModel.displayLabel
            this.modelInput.classList.add('completed')
            const modelChevron = this.modelInput.parentElement.querySelector('.input-chevron')
            if (modelChevron) {
              modelChevron.classList.add('hidden')
            }
            this.modelResetBtn.classList.remove('hidden')
            this.roofTypeInput.disabled = false
            this.updateUrlParams('model', matchingModel.model)
            this.updateUrlParams('doors', matchingModel.doors)
            this.setLastInput('model')
          }
        }
      } else {
        localStorage.removeItem('sharedVehicleInfo')
      }
    } catch (err) {
      localStorage.removeItem('sharedVehicleInfo')
    }
  }

  async restoreFromUrlParams (params) {
    try {
      const { make, model, doors, roofType, generation, lastInput } = params
      if (!make) return
      
      // Validate and restore make
      const normalizedUrlMake = this.normalizeString(make)
      const makeExists = this.getUniqueMakes().some(dbMake =>
        this.normalizeString(dbMake) === normalizedUrlMake,
      )
      
      if (makeExists) {
        const actualMake = this.getUniqueMakes().find(dbMake =>
          this.normalizeString(dbMake) === normalizedUrlMake,
        )
        
        // Restore make
        this.selectedMake = actualMake
        this.makeInput.value = actualMake
        this.makeInput.classList.add('completed')
        const makeChevron = this.makeInput.parentElement.querySelector('.input-chevron')
        if (makeChevron) {
          makeChevron.classList.add('hidden')
        }
        this.makeResetBtn.classList.remove('hidden')
        this.modelInput.disabled = false
        this.resetContainer.classList.remove('hidden')
        this.resetButton.classList.remove('hidden')
        this.classList.add('has-reset-button')
        
        // Restore model if provided
        if (model) {
          const uniqueModels = this.getUniqueModels(actualMake)
          const matchingModel = uniqueModels.find(item => 
            item.model === model && 
            (!doors || item.doors === doors),
          )
          
          if (matchingModel) {
            await new Promise(resolve => setTimeout(resolve, 100))
            this.selectedModel = matchingModel.model
            this.selectedDoors = matchingModel.doors
            this.modelInput.value = matchingModel.displayLabel
            this.modelInput.classList.add('completed')
            const modelChevron = this.modelInput.parentElement.querySelector('.input-chevron')
            if (modelChevron) {
              modelChevron.classList.add('hidden')
            }
            this.modelResetBtn.classList.remove('hidden')
            this.roofTypeInput.disabled = false
            
            // Restore roof type if provided
            if (roofType) {
              const roofTypes = this.getUniqueRoofTypes(actualMake, matchingModel.model, matchingModel.doors)
              const normalizedUrlRoofType = this.normalizeString(roofType)
              const roofTypeExists = roofTypes.some(type =>
                this.normalizeString(type) === normalizedUrlRoofType,
              )
              
              if (roofTypeExists) {
                const actualRoofType = roofTypes.find(type =>
                  this.normalizeString(type) === normalizedUrlRoofType,
                )
                
                await new Promise(resolve => setTimeout(resolve, 100))
                
                this.selectedRoofType = actualRoofType
                this.roofTypeInput.value = actualRoofType
                this.roofTypeInput.classList.add('completed')
                const roofTypeChevron = this.roofTypeInput.parentElement.querySelector('.input-chevron')
                if (roofTypeChevron) {
                  roofTypeChevron.classList.add('hidden')
                }
                this.roofTypeResetBtn.classList.remove('hidden')
                this.generationInput.disabled = false
                
                // Restore generation if provided
                if (generation) {
                  this.showGenerationSuggestions('')
                  await new Promise(resolve => setTimeout(resolve, 300))
                  
                  const generations = this.carData.filter((item) => {
                    const makeMatch = item.make === actualMake
                    const modelMatch = item.model === matchingModel.model
                    const typeMatch = item.type === actualRoofType
                    const doorsMatch = !matchingModel.doors || item.doors === matchingModel.doors
                    
                    return makeMatch && modelMatch && typeMatch && doorsMatch
                  })
                  
                  // Find matching generation
                  let matchingGeneration = null
                  if (generation === 'All') {
                    matchingGeneration = generations[0]
                  } else {
                    const [startYear, endYear] = generation.split('-')
                    matchingGeneration = generations.find(item => 
                      item.from_year === startYear && item.to_year === endYear,
                    )
                  }
                  
                  if (matchingGeneration) {
                    this.finalSelectedVehicle = matchingGeneration
                    this.selectedGeneration = generation
                    this.generationInput.value = generation
                    this.generationInput.classList.add('completed')
                    const generationChevron = this.generationInput.parentElement.querySelector('.input-chevron')
                    if (generationChevron) {
                      generationChevron.classList.add('hidden')
                    }
                    this.generationResetBtn.classList.remove('hidden')
                    
                    const productHandle = `summit-${matchingGeneration.roof_bars}-premium-aluminium-roof-bars`
                    this.fetchProductRecommendations(productHandle)
                  }
                } else {
                  setTimeout(() => {
                    this.showGenerationSuggestions('')
                  }, 200)
                }
              }
            }
          }
        }
        
        // Update shared storage
        this.updateSharedVehicleStorage(actualMake, model, doors)
        
        // Hide suggestions and focus appropriate input
        setTimeout(() => {
          if (this.selectedMake) {
            this.hideSuggestions(this.makeSuggestions)
          }
          if (this.selectedModel) {
            this.hideSuggestions(this.modelSuggestions)
          }
          if (this.selectedRoofType) {
            this.hideSuggestions(this.roofTypeSuggestions)
          }
          if (this.selectedGeneration) {
            this.hideSuggestions(this.generationSuggestions)
            document.activeElement.blur()
            return
          }
          
          // Focus next input based on current state or lastInput
          const nextInput = this.determineNextInput(lastInput)
          switch (nextInput) {
            case 'make':
              this.makeInput.focus()
              break
            case 'model':
              this.modelInput.focus()
              break
            case 'roofType':
              this.roofTypeInput.focus()
              break
            case 'generation':
              this.generationInput.focus()
              break
            default:
              document.activeElement.blur()
          }
        }, 300)
      } else {
        this.clearUrlParams()
      }
    } catch (err) {
      console.error('Error restoring from URL params:', err)
      this.clearUrlParams()
    }
  }

  getRoofTypeConfig () {
    if (this._roofTypeConfig) return this._roofTypeConfig
    const entries = [
      { keys: this.wording.roof_type_key_open_rails || 'Open rails', image: this.dataset.openRailsImage, label: this.wording.roof_type_open_rails || 'Open Rails' },
      { keys: this.wording.roof_type_key_closed_rails || 'Closed rails', image: this.dataset.closedRailsImage, label: this.wording.roof_type_closed_rails || 'Closed Rails' },
      { keys: this.wording.roof_type_key_plain_roof || 'Plain roof', image: this.dataset.plainRoofImage, label: this.wording.roof_type_plain_roof || 'Plain Roof' },
      { keys: this.wording.roof_type_key_fixed_points || 'Fixed points', image: this.dataset.fixedPointsImage, label: this.wording.roof_type_fixed_points || 'Fixed Points' },
      { keys: this.wording.roof_type_key_guttered || 'Guttered', image: this.dataset.gutteredImage, label: this.wording.roof_type_guttered || 'Guttered' },
    ]
    this._roofTypeConfig = new Map()
    for (const entry of entries) {
      const config = { image: entry.image, label: entry.label }
      entry.keys.split(',').forEach(key => {
        this._roofTypeConfig.set(key.trim().toLowerCase(), config)
      })
    }
    return this._roofTypeConfig
  }

  getUniqueRoofTypes (selectedMake, selectedModel, selectedDoors) {
    const lookup = {}
    const result = []
    for (const item of this.carData) {
      const makeMatch = item.make === selectedMake
      const modelMatch = item.model === selectedModel
      const doorsMatch = !selectedDoors || item.doors === selectedDoors
      
      if (makeMatch && modelMatch && doorsMatch) {
        const type = item.type
        if (!(type in lookup)) {
          lookup[type] = 1
          result.push(type)
        }
      }
    }
    return result
  }

  getCrossoverYears (selectedGeneration) {
    if (!this.selectedMake || !this.selectedModel || !this.selectedRoofType) {
      return []
    }
    
    const allGenerations = this.carData.filter((item) => {
      const makeMatch = item.make === this.selectedMake
      const modelMatch = item.model === this.selectedModel
      const typeMatch = item.type === this.selectedRoofType
      const doorsMatch = !this.selectedDoors || item.doors === this.selectedDoors
      
      return makeMatch && modelMatch && typeMatch && doorsMatch
    })
    
    if (allGenerations.length < 2) {
      return []
    }
    
    const crossoverYears = new Set()
    
    for (let i = 0; i < allGenerations.length; i++) {
      for (let j = i + 1; j < allGenerations.length; j++) {
        const gen1 = allGenerations[i]
        const gen2 = allGenerations[j]
        
        if (gen1.to_year && gen2.from_year && gen1.to_year === gen2.from_year) {
          crossoverYears.add(gen1.to_year)
        }
        
        if (gen2.to_year && gen1.from_year && gen2.to_year === gen1.from_year) {
          crossoverYears.add(gen2.to_year)
        }
      }
    }
    
    if (crossoverYears.size === 0) {
      return []
    }
    
    const selectedStartYear = selectedGeneration !== 'All' && selectedGeneration.includes('-')
      ? selectedGeneration.split('-')[0]
      : null
    const selectedEndYear = selectedGeneration !== 'All' && selectedGeneration.includes('-')
      ? selectedGeneration.split('-')[1]
      : null
    
    const relevantCrossoverYears = Array.from(crossoverYears).filter(year => {
      if (selectedGeneration === 'All') {
        return true
      }
      if (selectedStartYear && selectedEndYear) {
        return year >= selectedStartYear && year <= selectedEndYear
      }
      return false
    })
    
    return relevantCrossoverYears.sort()
  }

  showRoofTypeSuggestions (query = '') {
    if (!this.selectedModel) return
    const uniqueRoofTypes = this.getUniqueRoofTypes(this.selectedMake, this.selectedModel, this.selectedDoors)
    const roofTypeConfig = this.getRoofTypeConfig()
    const roofTypes = uniqueRoofTypes.map(type => {
      const config = roofTypeConfig.get(type.toLowerCase())
      return {
        value: type,
        label: config?.label || type,
        image: config?.image || '',
      }
    })
    const filtered = roofTypes.filter(type =>
      type.label.toLowerCase().includes(query.toLowerCase()),
    )
    this.renderRoofTypeSuggestions(filtered, this.roofTypeSuggestions)
  }

  renderRoofTypeSuggestions (items, container) {
    if (!container) return
    container.innerHTML = ''
    if (!items || !items.length) {
      container.classList.add('hidden')
      return
    }
    items.forEach(item => {
      const li = document.createElement('li')
      li.dataset.value = item.value || item.label
      li.dataset.label = item.label
      li.setAttribute('tabindex', '0')
      li.setAttribute('role', 'option')
      li.classList.add(
        'cursor-pointer',
        'mb-4',
        'last:mb-0',
        'relative',
        'group',
        'focus:outline-hidden',
        'flex',
        'items-center',
      )
      if (item.image) {
        const tickMarkHtml = `
           <div class="absolute top-[5px] right-[5px] w-4.5 h-4.5 bg-success rounded-full items-center justify-center hidden group-hover:flex group-focus:flex">
             <svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="white">
               <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
             </svg>
           </div>
         `
        li.innerHTML = `
           <div class="w-37.5 shrink-0">
             <div class="aspect-[2/1]">
               <img src="${item.image}" alt="" class="w-full h-full object-cover">
             </div>
           </div>
           <span class="p-4 flex-1">${item.label}</span>
           ${tickMarkHtml}
         `
      } else {
        li.textContent = item.label
      }
      container.appendChild(li)
    })
    container.classList.remove('hidden')
    container.setAttribute('role', 'listbox')
  }

  showGenerationSuggestions (query = '') {
    if (!this.selectedRoofType) {
      return
    }
    
    const MIN_YEAR = '1950'
    const CURRENT_YEAR = new Date().getFullYear().toString()
    const MAX_YEAR = (parseInt(CURRENT_YEAR) + 1).toString()
     
    const generations = this.carData.filter((item) => {
      const makeMatch = item.make === this.selectedMake
      const modelMatch = item.model === this.selectedModel
      const typeMatch = item.type === this.selectedRoofType
      const doorsMatch = !this.selectedDoors || item.doors === this.selectedDoors
      
      return makeMatch && modelMatch && typeMatch && doorsMatch
    })
     
    const generationItems = generations
      .filter(gen => {
        const startYear = gen.from_year || ''
        const endYear = gen.to_year || ''
         
        let isValid = true
        if (startYear && endYear) {
          isValid = (
            startYear >= MIN_YEAR &&
             endYear <= MAX_YEAR &&
             startYear <= endYear
          )
        } else if (!startYear && !endYear) {
          isValid = true
        }
         
        return isValid
      })
      .sort((a, b) => {
        const yearA = a.from_year || '0'
        const yearB = b.from_year || '0'
        return parseInt(yearB) - parseInt(yearA)
      })
      .map(gen => {
        const vanDims = gen.van_dims ? `${gen.van_dims}, ` : ''
        const markSeries = gen.mark_series ? `, ${gen.mark_series}` : ''
         
        let label
        if (gen.from_year && gen.to_year) {
          label = `${gen.from_year}-${gen.to_year} (${vanDims}${gen.body_type}${markSeries})`
        } else if (gen.body_type) {
          label = `${gen.body_type}${markSeries}`
        } else {
          label = 'All Years'
        }
         
        const value = gen.from_year && gen.to_year
          ? `${gen.from_year}-${gen.to_year}`
          : 'All'
         
        return {
          value,
          label,
          productHandle: `summit-${gen.roof_bars}-premium-aluminium-roof-bars`,
          note: gen.note,
          originalGen: gen,
        }
      })
      .filter(gen => gen.label.toLowerCase().includes(query.toLowerCase()))
     
    if (generationItems.length === 0) {
      this.generationSuggestions.classList.add('hidden')
      return
    }
    this.renderSuggestions(generationItems, this.generationSuggestions)
  }

  selectRoofType (roofType) {
    const selectedItem = this.roofTypeSuggestions.querySelector(`[data-value="${roofType}"]`)
    if (!selectedItem) return
    const displayLabel = selectedItem.dataset.label
    this.selectedRoofType = roofType
    this.roofTypeInput.value = displayLabel
    this.roofTypeInput.classList.add('completed')
    const roofTypeTick = this.roofTypeInput.parentElement.querySelector('.roof-bar-finder__input-tick')
    if (roofTypeTick) roofTypeTick.classList.remove('hidden')
    const chevron = this.roofTypeInput.parentElement.querySelector('.input-chevron')
    if (chevron) {
      chevron.classList.add('hidden')
    }
    this.roofTypeResetBtn.classList.remove('hidden')
    this.hideSuggestions(this.roofTypeSuggestions)
    this.updateUrlParams('roof_type', roofType)
    this.updateUrlParams('generation', null)
    this.setLastInput('roof_type')
    
    const generations = this.carData.filter((item) => {
      const makeMatch = item.make === this.selectedMake
      const modelMatch = item.model === this.selectedModel
      const typeMatch = item.type === this.selectedRoofType
      const doorsMatch = !this.selectedDoors || item.doors === this.selectedDoors
      
      return makeMatch && modelMatch && typeMatch && doorsMatch
    })
    
    if (generations.length === 1) {
      const generation = generations[0]
      const yearRange = generation.from_year && generation.to_year
        ? `${generation.from_year}-${generation.to_year}`
        : 'All'

      // First render the dropdown and then select after rendering is complete
      this.generationInput.disabled = false
      
      // Show generations first, then try to select
      this.showGenerationSuggestions('')
      
      // Wait for the suggestions to render before selecting
      setTimeout(() => {
        this.selectGeneration(yearRange)
      }, 300)
    } else {
      this.generationInput.disabled = false
      setTimeout(() => {
        this.generationInput.focus()
        this.showGenerationSuggestions('')
      }, 100)
    }
  }

  selectGeneration (generation) {
    const selectedItem = this.generationSuggestions.querySelector(`[data-value="${generation}"]`)
    if (!selectedItem) return

    this.selectedGeneration = generation
    this.generationInput.value = selectedItem.textContent.trim()
    this.generationInput.classList.add('completed')
    const generationTick = this.generationInput.parentElement.querySelector('.roof-bar-finder__input-tick')
    if (generationTick) generationTick.classList.remove('hidden')
    const chevron = this.generationInput.parentElement.querySelector('.input-chevron')
    if (chevron) {
      chevron.classList.add('hidden')
    }
    this.generationResetBtn.classList.remove('hidden')
    this.hideSuggestions(this.generationSuggestions)
    this.updateUrlParams('generation', generation)
    this.setLastInput('generation')
    
    // Set the finalSelectedVehicle - this is critical for results to work!
    let startYear, endYear
    if (generation !== 'All') {
      [startYear, endYear] = generation.split('-')
    }
    
    const generations = this.carData.filter((item) => {
      const makeMatch = item.make === this.selectedMake
      const modelMatch = item.model === this.selectedModel
      const typeMatch = item.type === this.selectedRoofType
      const doorsMatch = !this.selectedDoors || item.doors === this.selectedDoors
      
      // If generation is 'All', match without checking years
      if (generation === 'All') {
        return makeMatch && modelMatch && typeMatch && doorsMatch
      }
      
      // Otherwise match with years
      const yearMatch = item.from_year === startYear && item.to_year === endYear
      return makeMatch && modelMatch && typeMatch && doorsMatch && yearMatch
    })
    
    this.finalSelectedVehicle = generations[0]
    
    const handle = selectedItem.dataset.productHandle
    if (handle) {
      this.fetchProductRecommendations(handle)
    }
    this.generationInput.blur()
  }

  async fetchProductRecommendations (productHandle, attempt = 0) {
    try {
      const basePath = (window?.Shopify?.routes?.root || '/')
      const url = `${basePath}products/${productHandle}?section_id=product-card-roof-bar`
      const response = await fetch(url)
      if (!response.ok) {
        this.showNoProductFoundNotice()
        return
      }
      const html = await response.text()
      try {
        const hasLiquidError = html.includes('Liquid error')
        if (hasLiquidError) {
          // Attempt fallback handle mapping (e.g. SUP-A023 -> SURT-023)
          const altHandle = (() => {
            const supMatch = /^summit-SUP-A(\d{1,3})-premium-aluminium-roof-bars$/.exec(productHandle)
            if (supMatch) {
              const num = supMatch[1].padStart(3, '0')
              return `summit-SURT-${num}-premium-aluminium-roof-bars`
            }
            return null
          })()
          if (altHandle && altHandle !== productHandle && attempt < 2) {
            return this.fetchProductRecommendations(altHandle, attempt + 1)
          }
          this.showNoProductFoundNotice()
          return
        }
      } catch (e) {}
      const resultContainer = this.resultContainer
      if (!resultContainer) return
      const gridContainer = this.gridContainer
      if (!gridContainer) return
      
      const existingNotice = resultContainer.querySelector('.notice-body')?.closest('.flex')
      if (existingNotice) {
        existingNotice.remove()
      }
      
      gridContainer.innerHTML = html

      const productForm = gridContainer.querySelector('product-form')
      if (productForm) {
        if (productHandle) {
          productForm.dataset.productHandle = productHandle
        }
        if (this.selectedRoofType) {
          productForm.dataset.roofType = this.selectedRoofType
        }
      }

      resultContainer.classList.remove('hidden')
      
      // Show hidden sections when results are displayed
      this.showAllSections()
      
      // Hide initial notice container when results are shown
      if (this.initialNoticeContainer) {
        this.initialNoticeContainer.classList.add('hidden')
      }
      
      // Hide helper section when results are successfully shown
      if (this.helperSection) {
        this.helperSection.classList.add('hidden')
      }
      
      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init()
      }
      
      // Show note if the selected vehicle has one
      if (this.finalSelectedVehicle?.note) {
        const noticeElement = document.createElement('div')
        noticeElement.classList.add('flex', 'gap-3', 'items-start', 'rounded-lg', 'p-4', 'border', 'max-w-screen-xl', 'w-fit', 'mx-auto', 'bg-info-l', 'border-info', 'text-info', 'mt-12')
        noticeElement.innerHTML = `
          <div class="w-5 h-5">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
              <path fill-rule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="flex-1">
            <div class="notice-body tb-page-content tb-notice-body">${this.finalSelectedVehicle.note}</div>
          </div>
        `
        resultContainer.appendChild(noticeElement)
      }
      
      // Show crossover year warning if applicable
      const crossoverYears = this.getCrossoverYears(this.selectedGeneration)
      if (crossoverYears.length > 0 && this.wording.crossover_year_warning) {
        const yearText = crossoverYears.length === 1 
          ? crossoverYears[0]
          : crossoverYears.join(', ')
        const warningText = this.wording.crossover_year_warning.replace(/\[year\]/g, yearText)
        
        const warningElement = document.createElement('div')
        warningElement.classList.add('flex', 'gap-3', 'items-start', 'rounded-lg', 'p-4', 'border', 'max-w-screen-md', 'w-full', 'mx-auto', 'bg-alert-l', 'border-alert', 'text-alert', 'mb-8')
        warningElement.innerHTML = `
          <div class="w-5 h-5">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
              <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="flex-1">
            <div class="notice-body tb-page-content tb-notice-body">${warningText}</div>
          </div>
        `
        const productRecommendations = resultContainer.querySelector('#product-recommendations')
        if (productRecommendations && gridContainer) {
          productRecommendations.insertBefore(warningElement, gridContainer)
        }
      }
      
      // Scroll to results
      setTimeout(() => {
        const headerHeight = this.calculateHeaderHeight()
        const elementPosition = resultContainer.getBoundingClientRect().top
        const offsetPosition = elementPosition + window.pageYOffset - headerHeight
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        })
      }, 100)
      
      await this.logResult()
    } catch (error) {
      console.error('Error fetching product recommendations:', error)
      this.showNoProductFoundNotice()
    }
  }

  showNoProductFoundNotice () {
    const resultContainer = this.resultContainer
    if (!resultContainer) return
    const gridContainer = this.gridContainer
    if (gridContainer) {
      gridContainer.innerHTML = ''
    }
    resultContainer.classList.remove('hidden')
    const noticeElement = document.createElement('div')
    noticeElement.classList.add('flex', 'gap-3', 'items-start', 'rounded-lg', 'p-4', 'border', 'max-w-screen-xl', 'w-fit', 'mx-auto', 'bg-alert-l', 'border-alert', 'text-alert', 'mt-16')
    noticeElement.innerHTML = `
       <div class="w-5 h-5">
         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
           <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
         </svg>
       </div>
       <div class="flex-1">
         <div class="notice-body tb-page-content tb-notice-body">${this.wording.no_product_found_message || 'We couldn\'t find any roof bars for your vehicle. Please contact us for assistance.'}</div>
       </div>
     `
    const productRecommendations = resultContainer.querySelector('#product-recommendations')
    if (productRecommendations && gridContainer) {
      productRecommendations.insertBefore(noticeElement, gridContainer)
    }
  }

  resetFromModel () {
    this.modelInput.value = ''
    this.roofTypeInput.value = ''
    this.generationInput.value = ''
    this.modelInput.classList.remove('completed')
    this.roofTypeInput.classList.remove('completed')
    this.generationInput.classList.remove('completed')
    this.selectedModel = null
    this.selectedDoors = null
    this.selectedRoofType = null
    this.selectedGeneration = null
    this.updateUrlParams('model', null)
    this.updateUrlParams('doors', null)
    this.updateUrlParams('roof_type', null)
    this.updateUrlParams('generation', null)
    const modelChevron = this.modelInput.parentElement.querySelector('.input-chevron')
    if (modelChevron) {
      modelChevron.classList.remove('hidden')
    }
    const modelTick = this.modelInput.parentElement.querySelector('.roof-bar-finder__input-tick')
    if (modelTick) modelTick.classList.add('hidden')
    const roofTypeTick = this.roofTypeInput.parentElement.querySelector('.roof-bar-finder__input-tick')
    if (roofTypeTick) roofTypeTick.classList.add('hidden')
    const generationTick = this.generationInput.parentElement.querySelector('.roof-bar-finder__input-tick')
    if (generationTick) generationTick.classList.add('hidden')
    this.modelResetBtn.classList.add('hidden')
    this.roofTypeInput.disabled = true
    this.generationInput.disabled = true
    this.roofTypeResetBtn.classList.add('hidden')
    this.generationResetBtn.classList.add('hidden')
    this.clearResults()
    setTimeout(() => {
      this.modelInput.focus()
      this.showModelSuggestions('')
    }, 100)
  }

  resetFromRoofType () {
    this.roofTypeInput.value = ''
    this.generationInput.value = ''
    this.roofTypeInput.classList.remove('completed')
    this.generationInput.classList.remove('completed')
    this.selectedRoofType = null
    this.selectedGeneration = null
    this.updateUrlParams('roof_type', null)
    this.updateUrlParams('generation', null)
    const roofTypeChevron = this.roofTypeInput.parentElement.querySelector('.input-chevron')
    if (roofTypeChevron) {
      roofTypeChevron.classList.remove('hidden')
    }
    const roofTypeTick = this.roofTypeInput.parentElement.querySelector('.roof-bar-finder__input-tick')
    if (roofTypeTick) roofTypeTick.classList.add('hidden')
    const generationTick = this.generationInput.parentElement.querySelector('.roof-bar-finder__input-tick')
    if (generationTick) generationTick.classList.add('hidden')
    this.roofTypeResetBtn.classList.add('hidden')
    this.generationInput.disabled = true
    this.generationResetBtn.classList.add('hidden')
    this.clearResults()
    setTimeout(() => {
      this.roofTypeInput.focus()
      this.showRoofTypeSuggestions('')
    }, 100)
  }

  resetFromGeneration () {
    this.generationInput.value = ''
    this.generationInput.classList.remove('completed')
    this.selectedGeneration = null
    this.updateUrlParams('generation', null)
    const generationChevron = this.generationInput.parentElement.querySelector('.input-chevron')
    if (generationChevron) {
      generationChevron.classList.remove('hidden')
    }
    const generationTick = this.generationInput.parentElement.querySelector('.roof-bar-finder__input-tick')
    if (generationTick) generationTick.classList.add('hidden')
    this.generationResetBtn.classList.add('hidden')
    this.clearResults()
    setTimeout(() => {
      this.generationInput.focus()
      this.showGenerationSuggestions('')
    }, 100)
  }

  determineNextInput (lastInput) {
    if (this.selectedGeneration) {
      return null
    }
    if (lastInput) {
      if (lastInput === 'make' && !this.selectedModel) return 'model'
      if (lastInput === 'model' && !this.selectedRoofType) return 'roofType'
      if (lastInput === 'roof_type' && !this.selectedGeneration) return 'generation'
      if (lastInput === 'generation' && !this.selectedGeneration) return 'generation'
    }
    if (!this.selectedModel) return 'model'
    if (!this.selectedRoofType) return 'roofType'
    if (!this.selectedGeneration) return 'generation'
    return null
  }

  updateSharedVehicleStorage (make, model, doors) {
    try {
      localStorage.setItem('sharedVehicleInfo', JSON.stringify({
        make,
        model: model || undefined,
        doors: doors || undefined,
      }))
    } catch (e) {
      console.error('Error updating shared vehicle storage:', e)
    }
  }

  initializeStickyNotice () {
    if (!this.initialNoticeContainer || !this.toolCtaElement) {
      return
    }

    // Track user interaction
    this.addEventListener('click', () => {
      this.hasUserInteracted = true
    })
    this.addEventListener('focusin', () => {
      this.hasUserInteracted = true
    })

    // Set up intersection observer with dynamic offset based on header height
    const headerHeight = this.calculateHeaderHeight()
    const observerOffset = headerHeight + 100
    
    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && !this.hasUserInteracted) {
          this.showStickyNotice()
        } else {
          this.hideStickyNotice()
        }
      })
    }, {
      threshold: 0,
      rootMargin: `0px 0px -${observerOffset}px 0px`, // Dynamic offset based on header height + 100px
    })

    this.intersectionObserver.observe(this.toolCtaElement)

    // Handle click on notice to scroll to top
    this.initialNoticeContainer.addEventListener('click', (e) => {
      e.preventDefault()
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    })

    // Handle dynamic positioning
    this.updateNoticePosition()
    window.addEventListener('resize', () => this.updateNoticePosition())
  }

  calculateHeaderHeight () {
    let totalHeight = 0
    const isMobile = window.innerWidth < 768

    // Elements to consider for height calculation
    const headerElements = [
      '.site-header',
    ]

    // Add guide-steps-nav only on mobile
    if (isMobile) {
      headerElements.push('.guide-steps-nav')
    }

    headerElements.forEach(elementSelector => {
      const element = document.querySelector(elementSelector)
      if (element) {
        const rect = element.getBoundingClientRect()
        totalHeight += rect.height
      }
    })

    return totalHeight
  }

  updateNoticePosition () {
    if (!this.initialNoticeContainer) {
      return
    }
    
    const headerHeight = this.calculateHeaderHeight()
    this.initialNoticeContainer.style.top = `${headerHeight}px`
  }

  showStickyNotice () {
    if (!this.initialNoticeContainer) return
    
    // Update position before showing
    this.updateNoticePosition()
    
    this.initialNoticeContainer.classList.remove('opacity-0', 'invisible', 'pointer-events-none')
    this.initialNoticeContainer.classList.add('opacity-100', 'visible', 'pointer-events-auto')
  }

  hideStickyNotice () {
    if (!this.initialNoticeContainer) return
    
    this.initialNoticeContainer.classList.remove('opacity-100', 'visible', 'pointer-events-auto')
    this.initialNoticeContainer.classList.add('opacity-0', 'invisible', 'pointer-events-none')
  }

  disconnectedCallback () {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect()
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
    window.removeEventListener('resize', () => this.updateNoticePosition())
  }
}
 
if (!customElements.get('roof-bar-finder')) {
  customElements.define('roof-bar-finder', RoofBarFinderRedesign)
} 
